import custKnownWayReport from './custKnownWayReport'
export default custKnownWayReport
